import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Circle = createSvgIcon(
  () => (
    <path d="M24.2188 0C10.8398 0 0 10.8398 0 24.2188C0 37.5977 10.8398 48.4375 24.2188 48.4375C37.5977 48.4375 48.4375 37.5977 48.4375 24.2188C48.4375 10.8398 37.5977 0 24.2188 0ZM45.3125 24.2188C45.3125 35.8398 35.8398 45.3125 24.2188 45.3125C12.5977 45.3125 3.125 35.9375 3.125 24.2188C3.125 12.6953 12.5 3.125 24.2188 3.125C35.7422 3.125 45.3125 12.5977 45.3125 24.2188Z" />
  ),
  '0 0 49 49'
);
